import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Views from "./views";
import "./translations/i18n";
import moment from "moment";
import "moment/locale/nl";
import "moment/locale/en-gb";
import i18next from "i18next";
import { StyleProvider } from "@ant-design/cssinjs";
import { ConfigProvider } from "antd";
import "bootstrap/dist/css/bootstrap.css";
import nlNL from "antd/lib/locale/nl_NL";
import "./assets/css/globals.css";
import "dayjs/locale/nl";
import * as dayjs from "dayjs";

moment.locale(i18next.language);
dayjs.locale("nl");

const App = () => {
  return (
    <div className="App">
      <StyleProvider>
        <ConfigProvider
          locale={nlNL}
          theme={{
            token: {
              colorPrimary: "#1f6f19",
            },
          }}
        >
          <BrowserRouter>
            <Routes>
              <Route path="/*" element={<Views />} />
            </Routes>
          </BrowserRouter>
        </ConfigProvider>
      </StyleProvider>
    </div>
  );
};

export default App;
